import React from "react"
import autobind from "class-autobind"
import { TextField, Dialog, FlatButton, Toggle, SelectField, MenuItem } from "material-ui"
import ToolTip from "react-portal-tooltip"
import { grey500 } from "material-ui/styles/colors"
import strings from "../../localization/strings"
import AccountStore from "../../stores/AccountStore"
import * as utils from "../../helpers/utils"
import { IPayType } from "../../models"

class InfoIcon extends React.Component<{ id: string, tooltip: string }, { showTooltip: boolean }> {
	constructor(props) {
		super(props)
		this.state = {
			showTooltip: false
		}
		this.handleMouseEnter = this.handleMouseEnter.bind(this)
		this.handleMouseLeave = this.handleMouseLeave.bind(this)
	}

	handleMouseEnter() {
		this.setState({ showTooltip: true })
	}

	handleMouseLeave() {
		this.setState({ showTooltip: false })
	}

	render() {
		return (
			<div style={{ 
				display: 'inline-block',
				verticalAlign: 'middle',
				position: 'relative',
				top: '6px' 
			}}>
				<i
					id={this.props.id}
					className="fa fa-info-circle"
					style={{
						marginLeft: 8,
						color: grey500,
						cursor: "help",
						fontSize: 16,
						display: 'inline-block',
						verticalAlign: 'middle'
					}}
					onMouseEnter={this.handleMouseEnter}
					onMouseLeave={this.handleMouseLeave}
				/>
				<ToolTip
					active={this.state.showTooltip}
					position="right"
					arrow="center"
					parent={`#${this.props.id}`}
					style={{
						style: {
							backgroundColor: "white",
							boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
							padding: "8px 12px",
							maxWidth: 300,
							color: "rgba(0,0,0,0.87)",
							fontSize: 14,
							lineHeight: 1.4
						},
						arrowStyle: {
							color: "white",
							borderColor: false
						}
					}}
				>
					{this.props.tooltip}
				</ToolTip>
			</div>
		)
	}
}

interface IProps {
	editablePayType: IPayType
	payTypes: IPayType[]
	onRequestClose(): void
	handlerPayTypeSave(add: boolean, payType: IPayType): void
}
interface IState {
	name: string
	code: string
	nameError: string
	codeError: string
	paidTime: boolean
	creditAccrual: boolean
	useTowardsOvertime: boolean
	useRetroPayCode: boolean
	retroPayTypeId: string
	retroPayTypeIdError: string
	retroOTPayTypeId: string
	retroOT2PayTypeId: string
	nonProductiveTime: boolean
	useTowardsUtilizationCalculation: boolean
	excludeFromTimeTotals: boolean
	excludeChildPunchsetsFromTimeTotals: boolean
	excludeFromPayTypeTotals: boolean
	includeInPayTotals: boolean
}

export default class AddPayTypeDialog extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props)
		this.state = {
			name: props.editablePayType ? props.editablePayType.Name : "",
			code: props.editablePayType ? this.getDefaultCodeString(props.editablePayType.Name, props.editablePayType.Code) : "",
			nameError: "",
			codeError: "",
			paidTime: props.editablePayType ? props.editablePayType.PaidTime : true,
			creditAccrual: props.editablePayType ? props.editablePayType.CreditAccrual : false,
			useTowardsOvertime: props.editablePayType ? props.editablePayType.UseTowardsOvertime : false,
			useRetroPayCode: props.editablePayType ? props.editablePayType.UseRetroPayCode : false,
			retroPayTypeId: props.editablePayType ? props.editablePayType.RetroPayTypeId : null,
			retroPayTypeIdError: "",
			retroOTPayTypeId: props.editablePayType ? props.editablePayType.RetroOTPayTypeId : null,
			retroOT2PayTypeId: props.editablePayType ? props.editablePayType.RetroOT2PayTypeId : null,
			nonProductiveTime: props.editablePayType ? props.editablePayType.NonProductiveTime : false,
			useTowardsUtilizationCalculation: props.editablePayType ? props.editablePayType.UseTowardsUtilizationCalculation : true,
			excludeFromTimeTotals: props.editablePayType ? props.editablePayType.ExcludeFromTimeTotals : true,
			excludeChildPunchsetsFromTimeTotals: props.editablePayType ? props.editablePayType.ExcludeChildPunchesFromTimeTotals : true,
			excludeFromPayTypeTotals: props.editablePayType ? props.editablePayType.ExcludeFromPayTypeTotals : false,
			includeInPayTotals: props.editablePayType ? props.editablePayType.IncludeInPayTotals : false,
		}
		autobind(this)
	}

	getDefaultCodeString(name, code) {
		if (name) {
			if (code && code.length > 0) {
				return code;
			} else {
				if (!code || code.length == 0) {
					if (name && name.length > 0) {
						if (name.length >= 3) {
							code = name.substr(0, 3);
						} else {
							code = name;
						}
					}
				}
			}
		}

		return code.toUpperCase();
	}

	checkValidate(setCode = true) {
		let isValidate = true

		if (this.state.name.trim().length === 0) {
			this.setState({ nameError: strings.This_field_is_required })
			isValidate = false
		}
		else if (this.state.name.trim().length > 15) {
			//this.setState({ nameError: strings.Pay_Type_name_requires_maximum_15_chars })
			//isValidate = false
		}
		else if (this.props.payTypes
			.filter(i => this.props.editablePayType ? i.Id !== this.props.editablePayType.Id : true)
			.find(i => i.Name.toLowerCase() === this.state.name.trim().toLowerCase())
		) {
			//this.setState({ nameError: strings.The_name_must_be_unique })
			//isValidate = false
		}

		if (this.state.useRetroPayCode && !(this.state.retroPayTypeId && this.state.retroPayTypeId.length > 0)) {
			this.setState({ retroPayTypeIdError: strings.Pay_Type_Required })
			isValidate = false
		}

		const code = this.getDefaultCodeString(this.state.name, this.state.code)
		if (isValidate && setCode) {
			if (this.props.payTypes
				.filter(payType => this.props.editablePayType ? payType.Id !== this.props.editablePayType.Id : true)
				.find(payType => payType.Code === code.trim() && payType.Code && payType.Code.length > 0)
			) {
				this.setState({ codeError: strings.The_pay_type_code_must_be_unique })
				isValidate = false
			}

			//Setup code to match name substr 3 if code not manually set
			this.setState({ code });
		}

		return isValidate
	}

	handleRequestSave() {
		const validate = this.checkValidate(true)
		if (!validate) return

		const { name, code, paidTime, creditAccrual, useTowardsOvertime, useRetroPayCode, retroPayTypeId, retroOTPayTypeId,
			retroOT2PayTypeId, nonProductiveTime, useTowardsUtilizationCalculation, excludeFromTimeTotals, excludeChildPunchsetsFromTimeTotals, excludeFromPayTypeTotals, includeInPayTotals } = this.state
		const { editablePayType } = this.props

		const payType: IPayType = {
			Id: editablePayType ? editablePayType.Id : utils.guid(),
			Name: name.trim(),
			Code: this.getDefaultCodeString(name.trim(), code.trim()),
			PaidTime: paidTime,
			ExcludeFromTimeTotals: excludeFromTimeTotals,
			ExcludeChildPunchesFromTimeTotals: excludeChildPunchsetsFromTimeTotals,
			ExcludeFromPayTypeTotals: excludeFromPayTypeTotals,
			IncludeInPayTotals: includeInPayTotals,
			CreditAccrual: creditAccrual,
			UseTowardsOvertime: useTowardsOvertime,
			Deleted: false,
			UseRetroPayCode: useRetroPayCode,
			RetroPayTypeId: useRetroPayCode ? retroPayTypeId : null,
			RetroOTPayTypeId: useRetroPayCode && retroPayTypeId ? retroOTPayTypeId : null,
			RetroOT2PayTypeId: useRetroPayCode && retroPayTypeId && retroOTPayTypeId ? retroOT2PayTypeId : null,
			NonProductiveTime: nonProductiveTime,
			UseTowardsUtilizationCalculation: useTowardsUtilizationCalculation,
		}

		const add = editablePayType ? false : true
		this.props.handlerPayTypeSave(add, payType)
	}

	render() {
		return (
			<Dialog
				open
				style={{minHeight: 700}}
				title={this.props.editablePayType ? strings.Edit_Pay_Type + " - " + this.state.name : strings.New_Pay_Type}
				titleStyle={{ paddingLeft: 35, paddingBottom: 10 }}
				actions={[
					<FlatButton key="cancel" label={strings.CANCEL} secondary onTouchTap={this.props.onRequestClose} />,
					<FlatButton key="save" label={strings.SAVE} primary onTouchTap={this.handleRequestSave} />
				]}
			>
				<div style={{ padding: "0 35px" }}>
					<TextField
						data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Entry-Name"}
						floatingLabelText={strings.Name}
						value={this.state.name}
						style={{ width: "95%" }}
						onChange={(event, value) =>
							this.setState({
								name: value,
								nameError: ""
							}, () =>
								this.checkValidate(false)
							)
						}
						errorText={this.state.nameError}
						errorStyle={{ position: "absolute", bottom: -12 }}
					/>
					<TextField
						data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Entry-PayTypeCode"}
						floatingLabelText={strings.Pay_Type_Code}
						value={this.state.code}
						style={{ width: "95%" }}
						onChange={(event, value) => {
							if (value && value.length > 10) {
								value = value.substr(0, 10);
							}
							this.setState({
								code: value.toUpperCase(),
								codeError: ""
							}, () =>
								this.checkValidate(false)
							)
						}}
						errorText={this.state.codeError}
						errorStyle={{ position: "absolute", bottom: -12 }}
					/>
					<div style={{ display: "flex", alignItems: "center" }}>
						<Toggle
							style={{ width: "50%", marginTop: 20 }}
							data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Toggle-ProductiveTime"}
							toggled={this.state.nonProductiveTime}
							label={"Non-Productive Time"}
							onToggle={(_, nonProductiveTime) => this.setState({ nonProductiveTime })}
						/>
						<InfoIcon 
							id="non-productive-info"
							tooltip='This is time worked that does not directly contribute to productivity (i.e. training). It still counts towards overtime. This data can also be used to help determine staffing needs for the "Workforce Optimization Dashboard" and "Schedule Budget" modules.'
						/>
					</div>
					<div style={{ display: "flex", alignItems: "center" }}>
						<Toggle
							style={{ width: "50%", marginTop: 20 }}
							toggled={this.state.excludeFromTimeTotals}
							label={"Exclude From Time Totals"}
							onToggle={(_, excludeFromTimeTotals) => this.setState({ excludeFromTimeTotals })}
						/>
						<InfoIcon 
							id="exclude-time-totals-info"
							tooltip="This setting prevents time from being included in totals time calculations. For example, it could be used to exclude a parent punch set from total time calculations when using nested child punches to break out OT and REG calculations."
						/>
					</div>
					{this.state.excludeFromTimeTotals &&
						<div style={{ display: "flex", alignItems: "center" }}>
							<Toggle
								style={{ width: "50%", marginTop: 20 }}
								toggled={this.state.excludeChildPunchsetsFromTimeTotals}
								label={"Exclude Child Punchsets From Time Totals"}
								onToggle={(_, excludeChildPunchsetsFromTimeTotals) => this.setState({ excludeChildPunchsetsFromTimeTotals })}
							/>
							<InfoIcon 
								id="exclude-child-punchsets-info"
								tooltip="This setting prevents child punches from being included in time totals when the parent punch is excluded from time totals. This is useful for accurately calculating time totals when using nested child punches to break out OT and REG calculations."
							/>
						</div>
					}
					{AccountStore.getMedicalAccount() && (
						<div style={{ display: "flex", alignItems: "center" }}>
							<Toggle
								style={{ width: "50%", marginTop: 20 }}
								data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Toggle-UseTowardsUtilization"}
								toggled={this.state.useTowardsUtilizationCalculation}
								label={"Use Towards Utilization Calculation"}
								onToggle={(_, useTowardsUtilizationCalculation) => this.setState({ useTowardsUtilizationCalculation })}
							/>
							<InfoIcon 
								id="utilization-calc-info"
								tooltip="This setting is used to determine if the time worked will contribute to the employee's FTE utilization calculation. This data is used in the Workforce Optimization Dashboard to determine staffing needs and is based on the employee's scheduled hours and the actual hours worked."
							/>
						</div>
					)}
					{AccountStore.getPriorPeriodAdjustmentsEnabled() && (
						<div style={{ display: "flex", alignItems: "center" }}>
							<Toggle
								style={{ width: "50%", marginTop: 20 }}
								data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Toggle-UseRetroPayCode"}
								toggled={this.state.useRetroPayCode}
								label={strings.Define_Retro_Pay_Code}
								onToggle={(_, useRetroPayCode) => this.setState({ useRetroPayCode })}
							/>
							<InfoIcon 
								id="retro-pay-info"
								tooltip='When enabled, this setting allows you to specify a different pay type for retroactive pay calculations associated with the Prior Period Adjustment feature.'
							/>
						</div>
					)}
					<div style={{ display: "flex", alignItems: "center" }}>
						<Toggle
							style={{ width: "50%", marginTop: 20 }}
							data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Toggle-PaidTime"}
							toggled={this.state.paidTime}
							label={strings.Paid_Time}
							onToggle={(_, paidTime) => this.setState({ paidTime })}
						/>
						<InfoIcon 
							id="paid-time-info"
							tooltip='When enabled, this time is included in payroll exports and any timecard pay calculations. When disabled, the pay amount will be $0 in the timecard calculations and payroll export.'
						/>
					</div>
					<div style={{ display: "flex", alignItems: "center" }}>
						<Toggle
							style={{ width: "50%", marginTop: 20 }}
							data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Toggle-CreditAccrual"}
							toggled={this.state.creditAccrual}
							label={strings.Credit_Accrual}
							onToggle={(_, creditAccrual) => this.setState({ creditAccrual })}
						/>
						<InfoIcon 
							id="credit-accrual-info"
							tooltip="When enabled, the time calculation is used to contribute to accruals for benefits like PTO or sick leave."
						/>
					</div>
					<div style={{ display: "flex", alignItems: "center" }}>
						<Toggle
							style={{ width: "50%", marginTop: 20 }}
							data-intercom-target={"menu-AccountSettings-PayConfiguration-PayTypesTab-Add-Toggle-UseTowardsOvertime"}
							toggled={this.state.useTowardsOvertime}
							label={strings.Use_Towards_Overtime}
							onToggle={(_, useTowardsOvertime) => this.setState({ useTowardsOvertime,includeInPayTotals:false,excludeFromPayTypeTotals:false })}
						/>
						<InfoIcon 
							id="overtime-info"
							tooltip="When enabled, time totals are used to calculate overtime hours."
						/>
					</div>
					{!this.state.useTowardsOvertime && (
						<div style={{ display: "flex", alignItems: "center" }}>
							<Toggle
								style={{ width: "50%", marginTop: 20 }}
								toggled={this.state.excludeFromPayTypeTotals}
								label={"Exclude From Pay Type Totals"}
								onToggle={(_, excludeFromPayTypeTotals) => this.setState({ excludeFromPayTypeTotals })}
							/>
							<InfoIcon 
								id="exclude-pay-totals-info"
								tooltip='When enabled, this time is not included in the total for the pay type. This setting is only available when "Use Towards Overtime" is disabled.'
							/>
						</div>
					)}
					{this.state.useTowardsOvertime && (
						<div style={{ display: "flex", alignItems: "center" }}>
							<Toggle
								style={{ width: "50%", marginTop: 20 }}
								toggled={this.state.includeInPayTotals}
								label={"Include In Pay Type Totals"}
								onToggle={(_, includeInPayTotals) => this.setState({ includeInPayTotals })}
							/>
							<InfoIcon 
								id="include-pay-totals-info"
								tooltip='When enabled, the time totals are included in the total for the pay type and the overall time total. This allows the pay type total to be broken out as a line item in the daily and weekly timecard views. This setting is only available when "Use Towards Overtime" is enabled.'
							/>
						</div>
					)}
					{AccountStore.getPriorPeriodAdjustmentsEnabled() && this.state.useRetroPayCode &&
						<div style={{ display: "flex" }}>
							<SelectField
								data-intercom-target={"menu-AccountSettings-PayType-RetroAdjustment-DefaultPayType"}
								floatingLabelText={strings.Default_Pay_Type}
								value={this.state.retroPayTypeId}
								onChange={(event, key, retroPayTypeId) =>
									this.setState({
										retroPayTypeId,
										retroPayTypeIdError: ""
									}, () =>
										this.checkValidate(false)
									)
								}
								errorText={this.state.retroPayTypeIdError}
								errorStyle={{ position: "absolute", top: 70 }}
							>
								{this.props.payTypes.map((payType, key) =>
									<MenuItem key={key} value={payType.Id} primaryText={payType.Name} />
								)}
							</SelectField>
							{this.state.retroPayTypeId &&
								<SelectField
									data-intercom-target={"menu-AccountSettings-PayType-RetroAdjustment-DefaultOTPayType"}
									floatingLabelText={strings.Default_OT_Pay_Type}
									value={this.state.retroOTPayTypeId}
									onChange={(event, key, retroOTPayTypeId) => this.setState({ retroOTPayTypeId })}
									style={{ marginLeft: 25 }}
								>
									<MenuItem value={null} primaryText={""} />
									{this.props.payTypes.map((payType, key) =>
										<MenuItem key={key} value={payType.Id} primaryText={payType.Name} />
									)}
								</SelectField>
							}
							{!AccountStore.getHideOT2() && this.state.retroOTPayTypeId &&
								<SelectField
									data-intercom-target={"menu-AccountSettings-PayType-RetroAdjustment-DefaultOT2PayType"}
									floatingLabelText={strings.Default_OT2_Pay_Type}
									value={this.state.retroOT2PayTypeId}
									onChange={(event, key, retroOT2PayTypeId) => this.setState({ retroOT2PayTypeId })}
									style={{ marginLeft: 25 }}
								>
									<MenuItem value={null} primaryText={""} />
									{this.props.payTypes.map((payType, key) =>
										<MenuItem key={key} value={payType.Id} primaryText={payType.Name} />
									)}
								</SelectField>
							}
						</div>
					}
				</div>
			</Dialog>
		)
	}
}
